module.exports = __webpack_public_path__ + "static/img/map.62eec20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/map.png
// module id = Br0G
// module chunks = 2